

if (!customElements.get("product-form")) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector("form");
      this.form.addEventListener("submit", this.onSubmit.bind(this));
      this.querySelectorAll("[type='submit']").forEach((element) => {
        element.addEventListener("click", this.onClick.bind(this));
      });
      document
        .querySelectorAll(
          `[type='submit'][form='${this.form.getAttribute("id")}']`
        )
        .forEach((element) => {
          element.addEventListener("click", this.onClick.bind(this));
        });

      // Clear error message when variant options change
      this.addEventListener("change", this.clearErrorMessage.bind(this));
    }

    setSubmitted() {
      this.form.classList.add("submitted");
      document
        .querySelectorAll(`[form='${this.form.getAttribute("id")}']`)
        .forEach((element) => {
          element.classList.add("submitted");
        });
    }

    onClick(event) {
      this.setSubmitted();
      this.submitter = event.currentTarget;
    }

    async onSubmit(event) {
      event.preventDefault();
      this.handleErrorMessage(false);

      //Check form submission method
      let submittedByDispatch = function(){
        if(event.target.classList.contains('shippingProtectionForm')){
          return true
        } else {
          return false
        }
      }

      let submittedByVariantPicker = function(){
        if(event.detail != null){
          return true
        } else {
          return false
        }
      }

      const data = new FormData(this.form);
      const variantId = data.get("id");

      // Check if required variant options are actually selected
      if (!this.areRequiredVariantOptionsSelected()) {
        this.handleErrorMessage(this.getVariantSelectionMessage());
        return;
      }
      
      if (this.submitting || document.body.dataset.atcSubmitting === 'true') {
        return;
      }

      this.submitting = true;
      document.body.dataset.atcSubmitting = 'true';

      try {
        event.submitter && (this.submitter = event.submitter);
        document.querySelectorAll('product-form [type="submit"]').forEach(btn => {
          if (btn !== this.submitter) btn.setAttribute('aria-disabled', 'true');
        });

        if (!submittedByDispatch() && !submittedByVariantPicker()) {
          const cartNotification = document.querySelector("cart-notification");
          if (cartNotification && typeof cartNotification.setActiveElement === 'function') {
            cartNotification.setActiveElement(document.activeElement);
          }
          // Captured here, before the "ADDING..." overwrite below, so the
          // post-ADDED restore in delaySubmit() gets the real label (with its
          // live "- $price" span) instead of "ADDING..." itself. Recaptured
          // per submit so a variant change between adds stays current;
          // skipped only while "ADDED" itself is still on the button.
          if (!this.submitter.classList.contains("altLoader")) {
            this.submitter.dataset.originalLabel = this.submitter.innerHTML;
          }
          this.submitter.setAttribute("aria-disabled", true);
          this.submitter.innerHTML = ("ADDING...");
        }

        let obj = { quantity: 1 };
        for (let [name, value] of data) {
          const path = name.split('.');

          let index = -1,
            length = path.length,
            lastIndex = length - 1,
            nestedObj = obj;

          while (++index < length) {
            let key = path[index],
            objValue = value;

            if (index != lastIndex) {
              objValue = nestedObj[key];

              objValue = typeof objValue === 'object'
                ? objValue
                : {};
            }
            nestedObj[key] = objValue;
            nestedObj = nestedObj[key];
          }
        }


        // Gift Card inputs
        const sendGiftCardToRecipent = data.get('properties[__shopify_send_gift_card_to_recipient]') ? data.get('properties[__shopify_send_gift_card_to_recipient]') : false;
        const giftCardRecipentEmail = data.get('properties[Recipient email]') ? data.get('properties[Recipient email]') : false;
        const giftcardRecipentName = data.get("properties[Recipient name]") ? data.get("properties[Recipient name]") : false;
        const giftcardRecipentMessage = data.get("properties[Message]") ? data.get("properties[Message]") : false;
        const giftcardImage = document.querySelector('.gift-card-preview-image')?.src;

        // Check if Automation & Threshold properties exist with this product and apply to product properties accordingly.
        const specialInput = data.get("properties[_Special]") ? data.get("properties[_Special]") : false;
        const thresholdInput = data.get("properties[_Threshold]") ? parseInt(data.get("properties[_Threshold]")) : 0;
        const discountInput = data.get("properties[_Discount]") ? parseInt(data.get("properties[_Discount]")) : 0;
        const keyInput = data.get("properties[_Key]") ? data.get("properties[_Key]") : false;

        let specialProps = {};
        if(specialInput)
          specialProps['_Special'] = specialInput

        if(thresholdInput)
          specialProps['_Threshold'] = thresholdInput

        if(discountInput)
          specialProps['_Discount'] = discountInput

        if(keyInput)
          specialProps['_Key'] = keyInput

        if( sendGiftCardToRecipent ){
          specialProps = data.get('properties[Recipient email]') ? {
            'Message': giftcardRecipentMessage,
            'Recipient email' : giftCardRecipentEmail,
            'Recipent name' : giftcardRecipentName,
            '__image' : giftcardImage,
            '__shopify_send_gift_card_to_recipient' : sendGiftCardToRecipent
          } : {};
        }

        /* If Athlete is present, add the Athlete image. */
        const athleteInput = data.get("properties[Athlete]") ? data.get("properties[Athlete]") : false;
        if(athleteInput)
          specialProps['_Athlete'] = athleteInput;

        const config = window.fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        config.body = JSON.stringify({
          items: data.getAll("id").map((id) => ({
            ...obj,
            id,
            properties: specialProps
          })),
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        });

        // Optimistic drawer: the cart backend takes ~1s+ (Plus Scripts/bundle
        // pricing), so show the item in the drawer BEFORE the request instead
        // of after. PDP single-variant adds only — bundles and gift cards emit
        // no payload, subscriptions are excluded because the optimistic price
        // can't reflect the plan discount.
        let optimisticToken = null;
        const optimisticDrawer = document.querySelector("cart-drawer");
        if (
          optimisticDrawer &&
          typeof optimisticDrawer.showOptimistic === "function" &&
          this.isProductPage() &&
          !this.onCartPage() &&
          !submittedByDispatch() &&
          data.getAll("id").length === 1 &&
          !data.get("selling_plan") &&
          !sendGiftCardToRecipent
        ) {
          const payload = this.getOptimisticPayload(variantId, obj.quantity);
          if (payload) optimisticToken = optimisticDrawer.showOptimistic(payload);
        }

        try {
          // serializeCartAdd queues rapid adds so they don't fire concurrently
          // (the pattern Shopify throttles hardest).
          const doAdd = () => fetch(`${window.routes.cart_add_url}`, config);
          const response = await (window.serializeCartAdd ? window.serializeCartAdd(doAdd) : doAdd());

          // Check if response is ok before parsing JSON
          if (!response.ok) {
            const errorText = await response.text();
            let errorMessage;
            try {
              const errorJson = JSON.parse(errorText);
              errorMessage = errorJson.message || errorJson.description || errorText;
            } catch {
              errorMessage = errorText;
            }
            throw new Error(errorMessage);
          }

          const json = await response.json();

          if (json.status) {
            if (optimisticToken) optimisticDrawer.rollbackOptimistic(optimisticToken, json.description || 'Failed to add item to cart');
            this.handleErrorMessage(json.description || 'Failed to add item to cart');
          } else {
            if (optimisticToken) optimisticDrawer.resolveOptimistic(optimisticToken);
            try {
              this.renderLiveSections(json);
            } catch (e) {
              console.error('Failed to render sections after add to cart', e);
            }
            // Secondary cart sync (gift/donation/count refresh) is debounced so
            // rapid multi-add does not stampede the cart API. See global.js.
            if (typeof window.runPostAddChores === 'function') window.runPostAddChores();
          }
        } catch (error) {
          if (optimisticToken) optimisticDrawer.rollbackOptimistic(optimisticToken, error.message || 'Failed to add item to cart');
          this.handleErrorMessage(error.message || 'Failed to add item to cart');
        }

        if(submittedByVariantPicker()){
          setTimeout(()=>{
            if (typeof closeStickyVariantSelector === 'function') {
              closeStickyVariantSelector();
            }
          }, 1000)
        } else if (!submittedByDispatch()) {
          // originalLabel is captured earlier, above, before the "ADDING..."
          // overwrite — capturing it here (after innerHTML already reads
          // "ADDING...") is what made delaySubmit() restore "ADDING..."
          // instead of the real label.
          this.submitter.innerHTML = ("ADDED");
          this.submitter.classList.add("altLoader");
          setTimeout(()=>{
            this.delaySubmit(this.submitter)
          }, 1000)
        }

        // AutoGift / AutoDonation now run via the debounced window.runPostAddChores()
        // scheduled in the success branch above — see global.js.

      } finally {
        this.submitting = false;
        delete document.body.dataset.atcSubmitting;
        document.querySelectorAll('product-form [type="submit"]').forEach(btn => {
          if (btn !== this.submitter) btn.removeAttribute('aria-disabled');
        });
      }
    }
  
    delaySubmit(submitter) {
      submitter.removeAttribute("aria-disabled");
      submitter.classList.remove("altLoader");
      submitter.setAttribute("added", "true");
      submitter.innerHTML = submitter.dataset.originalLabel || "ADD TO CART";
    }

    // Reads the <script type="application/json" data-atc-product> blob emitted
    // by main-product-add-to-cart.liquid and shapes it into the optimistic row
    // payload for cart-drawer.js. Returns null (= no optimistic UI) whenever
    // anything is missing — the add then behaves exactly as before.
    getOptimisticPayload(variantId, quantity) {
      try {
        const el = this.querySelector('[data-atc-product]');
        if (!el) return null;
        const product = JSON.parse(el.textContent);
        const variant = product.variants && product.variants[variantId];
        if (!variant) return null;
        const parts = String(product.title || '').split(' - ');
        return {
          title: parts[0],
          subtitle: parts.slice(1).join(' - '),
          options: variant.options && variant.options !== 'Default Title' ? variant.options : '',
          url: product.url,
          image: variant.image,
          price: variant.price,
          quantity: parseInt(quantity, 10) || 1,
        };
      } catch (e) {
        return null;
      }
    }

    onCartPage() {
      return window.location.pathname.startsWith(window.routes.cart_url);
    }

    isProductPage() {
      return this.getAttribute("data-form") === "product";
    }

    getSectionsToRender() {
      if (this.onCartPage()) {
        const cartItems = document.querySelector("cart-items");
        const sections = cartItems ? cartItems.getSectionsToRender() : [];
        return sections;
      } else {
        const cartDrawer = document.querySelector("cart-drawer");
        const sections = [];

        if (cartDrawer) {
          sections.push(
            { section: "cart-drawer" },
            { section: "cart-icon-bubble" }
          );
        }

        if (!this.isProductPage()) {
          const cartNotification = document.querySelector("cart-notification");
          if (cartNotification) {
            sections.push(...cartNotification.getSectionsToRender());
          }
        }
        
        return sections;
      }
    }

    renderLiveSections(json) {
      const cartDrawer = document.querySelector("cart-drawer");
      
      if (this.onCartPage()) {
        const cartItems = document.querySelector("cart-items");
        cartItems.currentItemCount += 1;
        cartItems.render(json);
      } else if (this.isProductPage()) {
        if (cartDrawer) {
          cartDrawer.renderContents(json);
        }
      } else {
        const cartNotification = document.querySelector("cart-notification");
        if (cartNotification) {
          cartNotification.renderContents(json);
        }

        if (cartDrawer) {
          cartDrawer.renderContents(json, false);
        }
      }
    }

    areRequiredVariantOptionsSelected() {
      // Check if we're on a product page with variants
      if (!document.body.classList.contains('template-product') || this.querySelector('.list-card-product')) {
        return true;
      }

      // Find variant selectors to check if options are selected
      // Note: variant selectors are siblings to product-form, not children
      const productInfoContainer = this.closest('.product__info-container');
      const variantRadios = productInfoContainer ? productInfoContainer.querySelector('variant-radios') : document.querySelector('variant-radios');
      const variantSelects = productInfoContainer ? productInfoContainer.querySelector('variant-selects') : document.querySelector('variant-selects');
      
      if (variantRadios) {
        // For radio button variant pickers - check visible fieldsets
        const fieldsets = variantRadios.querySelectorAll('fieldset:not(.hidden)');
        
        for (let fieldset of fieldsets) {
          // Check if this fieldset has any radio buttons with checked state
          const hasCheckedRadio = fieldset.querySelector('input:checked');
          if (!hasCheckedRadio) {
            return false;
          }
        }
      } else if (variantSelects) {
        // For dropdown variant pickers
        const selects = variantSelects.querySelectorAll('select[required]');
        for (let select of selects) {
          if (!select.value || select.value === '') {
            return false;
          }
        }
      }
      
      return true;
    }

    getVariantSelectionMessage() {
      // Find variant selectors to determine what options need to be selected
      // Note: variant selectors are siblings to product-form, not children
      const productInfoContainer = this.closest('.product__info-container');
      const variantRadios = productInfoContainer ? productInfoContainer.querySelector('variant-radios') : document.querySelector('variant-radios');
      const variantSelects = productInfoContainer ? productInfoContainer.querySelector('variant-selects') : document.querySelector('variant-selects');
      
      let unselectedOptions = [];
      
      if (variantRadios) {
        // For radio button variant pickers - check visible fieldsets
        const fieldsets = variantRadios.querySelectorAll('fieldset:not(.hidden)');
        
        fieldsets.forEach(fieldset => {
          const legend = fieldset.querySelector('legend span');
          const hasCheckedRadio = fieldset.querySelector('input:checked');
          
          if (!hasCheckedRadio && legend) {
            unselectedOptions.push(legend.textContent.trim());
          }
        });
      } else if (variantSelects) {
        // For dropdown variant pickers
        const selects = variantSelects.querySelectorAll('select[required]');
        selects.forEach(select => {
          const label = variantSelects.querySelector(`label[for="${select.id}"]`);
          
          if ((!select.value || select.value === '') && label) {
            unselectedOptions.push(label.textContent.trim());
          }
        });
      }
      
      if (unselectedOptions.length > 0) {
        // Create specific message based on unselected options
        if (unselectedOptions.length === 1) {
          return `Pick a ${unselectedOptions[0]}!`;
        } else {
          const lastOption = unselectedOptions.pop();
          return `Pick ${unselectedOptions.join(', ')} and ${lastOption}!`;
        }
      }
      
      // Fallback message
      return 'Please select a product option before adding to cart.';
    }

    clearErrorMessage() {
      this.handleErrorMessage(false);
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector(".product-form__error-message-wrapper");
      
      if (!this.errorMessageWrapper) return;
      
      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector(".product-form__error-message");

      this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

      if (errorMessage && this.errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  }

  customElements.define("product-form", ProductForm);
}
